
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {SweetModal} from 'sweet-modal-vue';
import axiosInstance from '../../helpers/axios';
import session from '@/stores/Session';
import stores from '@/stores';
import NevronImageField from '@/components/NevronImageField.vue';
import {Dashboards} from '@/stores/Dashboard';

@Component({
  components: {
    SweetModal,
    NevronImageField,
  },
})
export default class CollectionItem extends Vue {

  services: any = [];
  mobileDashboards: any = [];
  combinedServices: any = [];
  selectedServiceOrDashboard: string = '';
  component: any = {
    elementType: 'BANNER1',
    linkAction: 'DIGITAL_SERVICE',
    linkModuleId: null,
    linkElementId: null,
    linkType: null,
    url: '',
    dashboardBackground: null,
    background: null
  };
  module: IDashboards = new Dashboards({name: 'dashboard', routeName: 'dashboard'});

  cancel() {
    // @ts-ignore
    this.$children[0].close();
    this.$emit('close');
  }

  imageSelected(image: IMediaItem) {
    if (this.component) {
      this.component.dashboardBackground = (image) ? image.id : null;
      this.component.background = image;
    }
  }

  handleExternalUrlChange() {
    // When external URL changes, clear service/dashboard selection
    if (this.component.linkAction === 'EXTERNAL_LINK') {
      this.selectedServiceOrDashboard = '';
      this.component.linkModuleId = null;
      this.component.linkElementId = null;
      this.component.linkType = null;
    }
  }

  handleServiceSelection(event: any) {
    const selectedValue = event.target.value;
    if (!selectedValue) {
      this.component.linkType = null;
      this.component.linkElementId = null;
      this.component.linkModuleId = null;
      return;
    }

    // Clear external URL when selecting service/dashboard
    this.component.url = '';
    // Ensure linkAction is set to DIGITAL_SERVICE when selecting from dropdown
    this.component.linkAction = 'DIGITAL_SERVICE';

    // Parse the selected value (format: 'service_123' or 'dashboard_456')
    const [type, id] = selectedValue.split('_');
    
    if (type === 'dashboard') {
      // For dashboard: use linkElementId, clear linkModuleId
      this.component.linkType = 'dashboard';
      this.component.linkElementId = id;
      this.component.linkModuleId = null;
    } else if (type === 'service') {
      // For service: use linkModuleId, clear linkElementId
      this.component.linkType = null;
      this.component.linkElementId = null;
      this.component.linkModuleId = id;
    }
  }

  @Watch('component.linkAction')
  onLinkActionChange(newAction: string) {
    if (newAction === 'EXTERNAL_LINK') {
      // When switching to external link, clear service/dashboard selection
      this.selectedServiceOrDashboard = '';
      this.component.linkModuleId = null;
      this.component.linkElementId = null;
      this.component.linkType = null;
    } else if (newAction === 'DIGITAL_SERVICE') {
      // When switching to digital service, clear external URL
      this.component.url = '';
    }
  }

  mounted() {
    // Load data immediately
    this.loadData();
  }

  // Method to ensure data is loaded (can be called when modal opens)
  ensureDataLoaded() {
    if (!this.combinedServices || this.combinedServices.length === 0) {
      this.loadData();
    }
  }

  async loadData() {
    try {
      // Initialize combinedServices as empty array if not already set
      if (!this.combinedServices) {
        this.combinedServices = [];
      }

      // Fetch both services and dashboards in parallel
      const [servicesResponse, dashboardsResponse] = await Promise.all([
        stores.modules.modules().catch((err) => {
          console.error('Error fetching services:', err);
          return [];
        }),
        stores.dashboards.fetchData(1, null, 100, 'Mobile').catch((err) => {
          console.error('Error fetching dashboards:', err);
          return { data: [] };
        })
      ]);

      // Services should be an array directly
      this.services = Array.isArray(servicesResponse) ? servicesResponse : [];
      
      // Dashboards come with a data property
      this.mobileDashboards = Array.isArray(dashboardsResponse?.data) ? dashboardsResponse.data : [];
      
      // If both are empty, log a warning
      if (this.services.length === 0 && this.mobileDashboards.length === 0) {
        console.warn('No services or dashboards loaded');
      }
      
      this.updateCombinedServices();
    } catch (error) {
      console.error('Error loading data:', error);
      this.services = [];
      this.mobileDashboards = [];
      this.updateCombinedServices();
    }
  }

  updateCombinedServices() {
    // Combine services and dashboards into a single array
    const servicesList = Array.isArray(this.services) 
      ? this.services.map((service: any) => ({
          ...service,
          type: 'service'
        }))
      : [];
    
    const dashboardsList = Array.isArray(this.mobileDashboards)
      ? this.mobileDashboards.map((dashboard: any) => ({
          ...dashboard,
          type: 'dashboard'
        }))
      : [];
    
    // Use Vue.set or direct assignment to ensure reactivity
    this.$set(this, 'combinedServices', [...servicesList, ...dashboardsList]);
  }

  next() {
    this.$emit('next', this.component);
    // @ts-ignore
    this.$children[0].close();
  }
}
